export interface ConfirmOptions {
  title?: string
  confirmLabel?: string
  cancelLabel?: string
  confirmColor?: string
  cancelColor?: string
  description?: string
  icon?: string
}

export function useConfirm() {
  const resolveFn = useState<((value: boolean) => void) | null>('confirm:resolveFn', () => null)
  const message = useState<string>('confirm:message', () => '')
  const visible = useState<boolean>('confirm:visible', () => false)
  const title = useState<string | undefined>('confirm:title', () => undefined)
  const confirmLabel = useState<string | undefined>('confirm:confirmLabel', () => undefined)
  const cancelLabel = useState<string | undefined>('confirm:cancelLabel', () => undefined)
  const confirmColor = useState<string | undefined>('confirm:confirmColor', () => undefined)
  const cancelColor = useState<string | undefined>('confirm:cancelColor', () => undefined)
  const description = useState<string | undefined>('confirm:description', () => undefined)
  const icon = useState<string | undefined>('confirm:icon', () => undefined)

  const confirm = (prompt: string, options?: ConfirmOptions): Promise<boolean> => {
    message.value = prompt
    title.value = options?.title
    confirmLabel.value = options?.confirmLabel
    cancelLabel.value = options?.cancelLabel
    confirmColor.value = options?.confirmColor
    cancelColor.value = options?.cancelColor
    description.value = options?.description
    icon.value = options?.icon
    visible.value = true

    return new Promise((resolve) => {
      resolveFn.value = resolve
    })
  }

  const close = (result: boolean) => {
    if (resolveFn.value) {
      resolveFn.value(result)
      resolveFn.value = null
    }
    visible.value = false
  }

  return {
    confirm,
    close,
    // state
    message,
    visible,
    title,
    confirmLabel,
    cancelLabel,
    confirmColor,
    cancelColor,
    description,
    icon,
  }
}
